import { Grid } from '@mui/material';
import { Drawer } from 'src/components/drawer';
import { InformationBox } from 'src/components/form/informationBox/InformationBox';
import { SidebarHeader } from 'src/components/header';
import { lang } from 'src/utils';

import { isDy } from '../../../EditComponentPage.helper';
import { ProductsSideBarController } from '../productsSideBarController/ProductsSideBarController';
import type { ProductsDrawerProps } from './ProductsDrawer.interface';
import { SidebarContainer, SidebarContent } from './ProductsDrawer.styled';

export const ProductsDrawer = (props: ProductsDrawerProps) => {
  return (
    <Drawer open={props.open}>
      <SidebarContainer>
        <SidebarHeader label={lang.products} onBackClick={props.onClose} />

        <SidebarContent>
          <Grid container gap={1}>
            <InformationBox
              visible={isDy(props.componentDetails.config?.productsSource)}>
              {lang.dyProductDescription}
            </InformationBox>

            <Grid item xs={12}>
              <ProductsSideBarController
                componentDetails={props.componentDetails}
                handleChange={props.handleOnChange}
                onToggleProductsDrawer={props.onClose}
              />
            </Grid>
          </Grid>
        </SidebarContent>
      </SidebarContainer>
    </Drawer>
  );
};
